import React, { Component } from 'react';
import mapboxgl from '!mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = process.env.GATSBY_MAPBOX_API_KEY;

class Map extends Component {
  constructor(props) {
    super(props);

    const { lng, lat, zoom, pubName, googlePlaceId } = this.props;

    this.state = {
      lng,
      lat,
      zoom,
      pubName,
      googlePlaceId
    };
  }

  componentDidMount() {
    const { lng, lat, zoom, pubName, googlePlaceId } = this.state;
    let directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + (googlePlaceId ? `${encodeURI(pubName)}&destination_place_id=${googlePlaceId}` : `${lat},${lng}`);

    const map = new mapboxgl.Map({ // eslint-disable-line
      container: this.mapContainer,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: zoom
    })

    // Add zoom and rotation controls to the map.
    map.addControl(new mapboxgl.NavigationControl());

    map.on('load', function () {
      map.loadImage(
        'https://rob-cdn.ams3.digitaloceanspaces.com/website/general/map-marker.png',
        function (error, image) {
          if (error) throw error;
          map.addImage('marker', image);
          map.addSource('point', {
              'type': 'geojson',
              'data': {
                  'type': 'FeatureCollection',
                  'features': [{
                      'type': 'Feature',
                      'geometry': {
                          'type': 'Point',
                          'coordinates': [lng, lat]
                      }
                  }]
              }
          });
          map.addLayer({
            'id': 'points',
            'type': 'symbol',
            'source': 'point',
            'layout': {
              'icon-image': 'marker',
              'icon-size': 1
            }
          });
          map.on('click', 'points', (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = e.features[0].properties.description;

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }

            new mapboxgl.Popup({offset: 32})
              .setLngLat(coordinates)
              .setHTML('<h3>' + pubName + '</h3><a target="_blank" href="' + directionsUrl + '">Get Directions</a>')
              .addTo(map);
          });

          map.on('mouseenter', 'points', () => {
            map.getCanvas().style.cursor = 'pointer';
          });

          // Change it back to a pointer when it leaves.
          map.on('mouseleave', 'points', () => {
            map.getCanvas().style.cursor = '';
          });
        }
      );
    });
  }

  render() {
    return <div ref={el => this.mapContainer = el} className={this.props.className} />;
  }
}

export default Map;
